import { BetNotificationWr, SlowConnectionWr, UnderMaintenanceWr } from '@pascal/pascal-core';

import { BetBlock, GameBlock } from '../common';
import BetSection from '../../components/web/betSection';
import GameSection from '../../components/web/gameSection';
import { MainBetsWrapper } from '../common/gameBetTabs/mainBetsWrapper';

const WebGame = () => {
  return (
    <div className='game'>
      <div className='middle-main-cont-wrp'>
        <div className='m-content-top'>
          <div className='content-top-inner'>
            <BetNotificationWr />
            <UnderMaintenanceWr />
            <SlowConnectionWr />
            <GameBlock innerComp={GameSection} />
          </div>
        </div>
        <div className='m-content-middle'>
          <MainBetsWrapper />
        </div>
        <div className='m-content-bottom'>
          <BetBlock innerComp={BetSection} />
        </div>
      </div>
    </div>
  );
};

export default WebGame;
